import IPinfoWrapper from 'node-ipinfo'

import { triggerSimpleAjax } from '../http-helper'

const getLocaleCode = (code = '') => {
	const SUPPORTED_LOCALE = ['us', 'ae', 'uk', 'gb', 'it', 'de', 'fr']
	let currentCode = code ? code : ''
	if (currentCode.toLowerCase() === 'in') {
		return ''
	} else if (SUPPORTED_LOCALE.indexOf(currentCode.toLowerCase()) > -1) {
		return currentCode.toLowerCase()
	} else {
		return ''
	}
}

export const fetchLocaleInfoFromApi = () => {
	return new Promise((res, rej) => {
		// pickyourtrail.com/locale - Front-end API built in nodejs (veho-react's server)
		let url = `/locale`
		triggerSimpleAjax({
			url,
			method: 'GET',
			body: {},
			onSuccess: response => {
				res({ ...response })
			},
			onFailure: error => {
				return rej(error)
			},
		})
	})
}

export const fetchLocaleFromUrl = async reqData => {
	const urlArr = reqData.url?.split('/')
	console.log({ urlArr }, { reqPath: reqData.url })
	let localeCode = ''

	if (urlArr && urlArr[1] && urlArr[1].length === 2) {
		localeCode = getLocaleCode(urlArr[1])
		// eslint-disable-next-line no-console
		console.log('--------locale from 1st-----', { localeCode })
	}

	return localeCode
}

const fetchLocaleInfo = async (reqData = {}, skipUrl = false) => {
	// console.log("reqData headers ********: ",reqData.headers);
	console.log({ skipUrl })
	console.log(
		'reqData x-forwarded-for ********: ',
		reqData.headers['x-forwarded-for'],
	)
	console.log(
		'reqData cloudfront-viewer-country ********: ',
		reqData.headers['cloudfront-viewer-country'],
	)
	console.log(
		'reqData remoteAddress ********: ',
		reqData.connection?.remoteAddress,
	)
	// console.log("reqData ********: ",reqData);
	// return "";
	let localeCode = ''

	const urlArr = reqData.url?.split('/')
	console.log({ urlArr }, { reqPath: reqData.url })
	const ip =
		reqData.headers['x-forwarded-for'] || reqData.connection?.remoteAddress

	if (/[.]/.test(reqData.url)) {
		return
	} else if (!skipUrl && urlArr && urlArr[1] && urlArr[1].length === 2) {
		localeCode = getLocaleCode(urlArr[1])
		// eslint-disable-next-line no-console
		console.log('--------locale from 1st-----', { localeCode })
	} else if (!skipUrl && (ip === '::1' || ip === '::ffff:127.0.0.1')) {
		localeCode = ''
		// eslint-disable-next-line no-console
		console.log('--------locale from local 2nd-----', { localeCode })
	} else if (reqData.headers['cloudfront-viewer-country']) {
		let newCode = reqData.headers['cloudfront-viewer-country']
		localeCode = getLocaleCode(newCode)
		// eslint-disable-next-line no-console
		console.log('--------locale from 3rd-----', { localeCode })
	} else {
		const token = '650c864aee93d6'
		const ipinfoWrapper = new IPinfoWrapper(token)
		await ipinfoWrapper
			.lookupIp(ip)
			.then(response => {
				console.log({ response })
				localeCode = getLocaleCode(response.countryPhoneCode)
				// eslint-disable-next-line no-console
				console.log('--------locale from ipinfo 4th-----', { localeCode })
			})
			.catch(() => {
				localeCode = ''

				console.log('--------IP Lookup Error-----', { localeCode })
				// logger.error(`IP Lookup Error`);
			})

		// eslint-disable-next-line no-console
		console.log('--------Into the 4th block of IP check-----', { localeCode })
	}

	return localeCode
}

export default fetchLocaleInfo
